import React, { useState, useEffect, useRef } from "react";
import HRSightLogo from "../../assets/hrsight-logo.png";
import "./Header.css";
import HeaderSearch from "../../features/Employee/HeaderSearch";
import HeaderNotification from "../../features/Employee/HeaderNotification";
import HeaderUser from "../../features/Employee/HeaderUser";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleBurgerClick = () => {
    setIsMenuOpen(!isMenuOpen);
    const event = new CustomEvent("toggle-subheader");
    window.dispatchEvent(event);
  };

  return (
    <div className="employee-header">
      <div className="header-left">
        <button
          className={`burger-button-header ${isMenuOpen ? "open" : ""}`}
          onClick={handleBurgerClick}
        >
          <span className="burger-bar"></span>
          <span className="burger-bar"></span>
          <span className="burger-bar"></span>
        </button>
        <img src={HRSightLogo} className="hrsight-logo" alt="HR Sight Logo" />
      </div>

      <div className="employee-header-options">
        <HeaderSearch />
        <HeaderNotification />
        <HeaderUser />
      </div>
    </div>
  );
}

export default Header;
